export default "__VITE_ASSET__Cud5aD8c__"